<template>
  <sl-table ref="table" :loading="loading" :page="page" :columns="columns" :data="data" @on-selection-change="handleSelect" @on-update="handleChange"></sl-table>
</template>
<script>

export default {
  components: { },
  data() {

    return {
      data: [],
      params: {
        tradeSerialNum: null,
        payStatus: null,
        tradeObjType: null,
        carNo:null,
        tradeType:1,
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      columns:[{
          type: 'index',
          minWidth: 65,
          title: '序号',
          align: 'center'
        },
        {
          minWidth: 90,
          title: '车辆编号',
          key: 'carNo'
        },
        {
          title: '流水号',
          key: 'childTradeSerialNum',
          minWidth: 190,
        },
        {
          title: '事由',
          key: 'tradeObjName',
          minWidth: 110,
        },
        {
          title: '金额',
          key: 'payAmount',
          minWidth: 90,
        },
        {
          title: '扣款时间',
          key: 'tradeDatetimeText',
          minWidth: 160,
        }],
      loading: false,
      selection: []
    }
  },
  computed: {
    removeDisable() {
      return this.selection.length == 0
    },
  },

  props: {
    carId: {
      type: [Number, String]
    }
  },

  watch: {
    carId(val) {
      if (val) {
        this.list()
      }
    }
  },

  created() {
    this.def = { ...this.params }
  },

  methods: {

    list() {
      let params = { search: {carId:this.carId ,...this.params}, pageSize: this.page.pageSize, pageNum: this.page.pageNum }

      this.loading = true
      this.$request.invoices(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data.list || [], { 'tradeType': '$tradeType', 'tradeDatetime': 'datetime', 'tradeObjType': '$paySource', 'payType': '$payType', 'payStatus': '$payStatus' })

          this.page.total = resp.data.total || 0
        }
      })
    },
    view({ row }) {
      this.loading = true
      this.$request.invoice(row.tradeSerialNum).then(resp => {
        let data = resp.data || {}
        this.loading = false
        this.$dialog.info({
          onOk:()=>{
            this.list()
          },
          render: (h) => {
            return <sl-detail-list col={1}>
              <sl-detail-list-item title="流水号" content={data.outTradeNo} />
              <sl-detail-list-item title="支付状态" content={['TRADE_SUCCESS', 'TRADE_FINISHED'].includes(data.tradeStatus) ? '已支付' : '未支付'} />
            </sl-detail-list>
          }
        })
      })
    },
    create() {
      this.$refs['item'].init(0)
    },

    remove({ row }) {
      this.$ui.confirm(this.$request.invoiceDelete, `确定删除 ${row.name} ？`)(row.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.selection = []
          this.list()
        } else {
          this.$Notice.error({
            title: '删除发生错误',
            desc: resp.msg,
          });
        }
      })
    },

    toggle({ row }) {

    },

    reset() {
      this.$utils.fill(this.params, this.def)
      console.log(this.params)
      this.list()
    },

    handleUpdate() {
      this.modalVisible = false
      this.list()
    },

    handleChange(pageNum, pageSize) {
      if (this.page.pageNum != pageNum || this.page.pageSize != pageSize) {
        this.page.pageNum = pageNum
        this.page.pageSize = pageSize
        this.list()
      }
    },

    handleSelect(selection) {
      this.selection = selection.map(i => i.id)
    }
  }
}

</script>
